/**
 * Import Component (.vue)
 * For Async Component Syntax
 * const X = () => import('@/pages/xxx/xxx.vue')
 */
// import Login from './Login'
import LoginAdmin from './LoginAdmin'
import LoginTeacher from './LoginTeacher'
import LoginUser from './LoginUser'
import Logout from './Logout'
import ChangePassword from './ChangePassword' // 비밀번호 변경
import PageNotFound from './errors/404'
import Admin from './Admin' // 관리자 View
import Main from './Main' // 관리자 메인
import M990101 from './M990101' // 메뉴관리
import M990102 from './M990102' // 메뉴상세
import M990201 from './M990201' // 사용자관리
import M990202 from './M990202' // 사용자등록
import M990203 from './M990203' // 사용자상세
import M990301 from './M990301' // 권한관리
import M990401 from './M990401' // 카테고리
import M990402 from './M990402' // 카테고리
import M990501 from './M990501' // 공통코드
import M990502 from './M990502' // 공통코드상세
import M990601 from './M990601' // 공지사항
import M990602 from './M990602' // 사용자상세
import M990701 from './M990701' // 카카오 알림톡 템플릿 관리
import M990702 from './M990702' // 카카오 알림톡 발신번호 관리
import M990801 from './M990801' // 카카오 알림톡 히스토리
import M991001 from './M991001' // 회원가입 승인
import M010101 from './M010101' // 교재관리
import M020101 from './M020101' // 수강관리
import M020102 from './M020102' // 클래스등록
import M020103 from './M020103' // 클래스상세
import M020104 from './M020104' // 출석체크
import M020105 from './M020105' // 출석설정
import M020106 from './M020106' // 출석체크(수정)
import M030101 from './M030101' // 문제관리
import M030103 from './M030103' // 문제관리(수정)
import M030102 from './M030102' // 문제상세
import M040101 from './M040101' // 시험지관리
import M040102 from './M040102' // 시험지상세
import M050101 from './M050101' // 시험관리
import M050102 from './M050102' // 시험등록
import M050103 from './M050103' // 시험상세
import M050201 from './M050201' // 오답노트
import M050202 from './M050202' // 오답노트상세
import M060101 from './M060101' // 시험별 성적표
import M060102 from './M060102' // 시험별 성적 상세
import M060103 from './M060103' // 성적표 상세
import M060201 from './M060201' // 수강반별 성적표
import M060202 from './M060202' // 수강반별 성적표 상세
import M060301 from './M060301' // 회독 성적표
import M060302 from './M060302' // 회독 성적표 대상
import M060303 from './M060303' // 회독 성적표 상세
import M060401 from './M060401' // 종합 성적표
import M060402 from './M060402' // 종합 성적표 대상
import M060403 from './M060403' // 종합 성적표 대상_2
import M070101 from './M070101' // 성적분포
import M070102 from './M070102' // 성적분포상세
import M070201 from './M070201' // 문제별상세분석
import M070202 from './M070202' // 문제별상세분석-문제상세
import M080101 from './M080101' // 수강생관리
import M080102 from './M080102' // 수강생등록
import M080103 from './M080103' // 수강생수정
import M080104 from './M080104' // 수강생시험리스트
import User from './User' // 사용자 View
import Agreement from './Agreement' // 사용자 가입 약관
import Join from './Join' // 회원가입요청 양식
import SignUp from './SignUp' // 회원가입 양식
import S010101 from './S010101' // 시험보기
import S010102 from './S010102' // 시험답안지
import S010201 from './S010201' // 시험성적
import S010202 from './S010202' // 종합성적표
import S010301 from './S010301' // 공지사항
import S010401 from './S010401' // 공지사항
import S990101 from './S990101' // 마이페이지
import S990102 from './S990102' // 회원탈퇴
import R000000 from './R000000'
import R000001 from './R000001'
import R010101 from './R010101' // 채점표
import R010201 from './R010201' // 성적표(채점표/개인)
import R010203 from './R010203' // 회독 성적표(종합)
import R010301 from './R010301' // 회독 성적표
import BlankPage from './BlankPage' // 빈페이지

export default {
  LoginAdmin,
  LoginTeacher,
  LoginUser,
  Logout,
  ChangePassword,
  PageNotFound,
  Admin,
  Main,
  M010101,
  M020101,
  M020102,
  M020103,
  M020104,
  M020105,
  M020106,
  M030101,
  M030102,
  M030103,
  M040101,
  M040102,
  M050101,
  M050102,
  M050103,
  M050201,
  M050202,
  M060101,
  M060102,
  M060103,
  M060201,
  M060202,
  M060301,
  M060302,
  M060303,
  M060401,
  M060402,
  M060403,
  M070101,
  M070102,
  M070201,
  M070202,
  M080101,
  M080102,
  M080103,
  M080104,
  M990101,
  M990102,
  M990201,
  M990202,
  M990203,
  M990301,
  M990401,
  M990402,
  M990501,
  M990502,
  M990601,
  M990602,
  M990701,
  M990702,
  M990801,
  M991001,
  User,
  Agreement,
  Join,
  SignUp,
  S010101,
  S010102,
  S010201,
  S010202,
  S010301,
  S010401,
  S990101,
  S990102,
  R000000,
  R000001,
  R010101,
  R010201,
  R010203,
  R010301,
  BlankPage
}



// WEBPACK FOOTER //
// ./src/pages/index.js